<template>
  <img
    draggable="false"
    class="mk-image"
    :src="tempValue"
  />
</template>

<script>
export default {
  name: "MkImage",
  props: {
    value: {
      type: String,
      default: "https://mks.yybip.com/group1/M00/00/84/CgoRC1mSq5mADGtvAAK00fp5jSE786.jpg",
    },
  },
  data() {
    return {
      tempValue: "/",
    };
  },
  created() {
    this.tempValue = this.value;
  },
  watch: {
    value(val) {
      this.tempValue = val;
    },
    tempValue() {
      this.$emit("input", this.tempValue);
    },
  },
};
</script>

<style scoped lang="scss">
.mk-image {
  width: 100%;
  height: 100%;
}
</style>
